import { FC } from 'react';
import { AplautReviewsTypeProps } from '../../module/types/TypeProps';
import { useConnectScriptAplaut } from '../../module/hooks/useConnectScriptAplaut';
import classNames from 'classnames';
import { SkeletonLoading } from '@app/shared';

import styles from './AplautReviews.module.scss';

export const AplautReviews: FC<AplautReviewsTypeProps> = ({ className, productRN, elementId }) => {
  const { isLoaded } = useConnectScriptAplaut({ productRN, elementId });
  return (
    <div id="reviews_content" className={classNames(styles.WrapperAplautReviews, className)}>
      {isLoaded ? <div id={elementId} /> : <SkeletonLoading width={'100%'} height={'40vh'} />}
    </div>
  );
};
